<div class="uk-container">
	<div class="ServicesHeading">
		<h1>Заказы</h1>
	</div>

	<div class="uk-alert-warning" uk-alert *ngIf="items.length === 0">
		<h3>У Вас пока нет заказов</h3>
	</div>

	<div *ngIf="items.length > 0" class="uk-overflow-auto">
		<table class="PersonalTable uk-table">
			<thead>
				<tr>
					<th class="uk-text-center">Номер заказа</th>
					<th class="uk-text-center">Товары</th>
					<th class="uk-text-center">Оплата</th>
				</tr>
			</thead>

			<tbody>
				<tr *ngFor="let order of items">
					<td>
						<div>N-{{ order.ID }}</div>
						<div>от {{ order.DATE_INSERT|date:'dd.MM.yyyy' }}</div>
					</td>

					<td>
						<div class="uk-overflow-auto">
							<table class="uk-table uk-table-justify">
								<tbody>
									<tr *ngFor="let item of order.BASKET" class="PersonalTable_Product">
										<td class="uk-width-2-3"><a [routerLink]="item.DETAIL_PAGE_URL">{{ item['ELEMENT:NAME'] }}</a></td>
										<td class="uk-width-1-6 uk-text-nowrap">{{ item.QUANTITY * 1 }}</td>
										<td class="uk-width-1-6 uk-text-nowrap">{{ (item.QUANTITY * item.PRICE)|currency:item.CURRENCY:'symbol':'1.0-0' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</td>

					<td>
						<div>{{ order.PRICE|currency:order.CURRENCY:'symbol':'1.0-0' }}</div>
						<div *ngIf="order.PAYED === 'Y'" class="uk-text-success uk-text-small">Оплачен</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="uk-text-center uk-margin-large-top" *ngIf="items.length > 0 && !isLastPage">
      <button class="BtnMore uk-text-primary uk-icon"
		  (click)="loadMore()"
		  [disabled]="loadingState"
		  [ngClass]="loadingState ? 'uk-button-loading' : ''">
		  <span uk-icon="icon: plus; ratio: 2"></span>
	  </button>
    </div>
</div>
